@if (!isSmallScreen) {
  <mat-grid-list
    class="dashboard-grid dashboard-grid-fill"
    [cols]="5"
    rowHeight="fit"
    gutterSize="1rem">
    <mat-grid-tile [colspan]="2">
      <ng-container [ngTemplateOutlet]="activeCasesCard"></ng-container>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <ng-container [ngTemplateOutlet]="recentOrdersCard"></ng-container>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="5" [rowspan]="2">
      <ng-container [ngTemplateOutlet]="ordersChartCard"></ng-container>
    </mat-grid-tile>
  </mat-grid-list>
} @else {
  <div class="dashboard-mobile-stack d-flex flex-column gap-3">
    <ng-container [ngTemplateOutlet]="activeCasesCard"></ng-container>
    <ng-container [ngTemplateOutlet]="recentOrdersCard"></ng-container>
    <ng-container [ngTemplateOutlet]="ordersChartCard"></ng-container>
  </div>
}

<ng-template #activeCasesCard>
  <div class="card app-card dashboard-tile-card">
    <div class="card-body p-4 text-center d-flex flex-column justify-content-center">
      @if (loadingSummary) {
        <app-loading-spinner></app-loading-spinner>
      } @else if (summaryError) {
        <app-error-alert class="d-block" [message]="summaryError"></app-error-alert>
      } @else {
        <div class="dashboard-active-cases-number fw-bold my-3 primary-color">{{ activeCases }}</div>
      }
      <div class="dashboard-active-cases-label text-muted">Активни налози</div>
    </div>
  </div>
</ng-template>

<ng-template #recentOrdersCard>
  <div class="card app-card dashboard-tile-card">
    <div class="card-body dashboard-card-body p-3 d-flex flex-column">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0">Последни налози</h5>
      </div>
      @if (loadingOrders) {
        <app-loading-spinner></app-loading-spinner>
      } @else if (ordersError) {
        <app-error-alert class="d-block" [message]="ordersError"></app-error-alert>
      } @else if (recentOrders.length > 0) {
        <div class="table-responsive">
          <table class="table table-hover align-middle text-nowrap mb-0">
            <thead>
              <tr>
                <th>Налог</th>
                <th>Пациент</th>
                <th>Статус</th>
                <th class="text-end">Датум</th>
              </tr>
            </thead>
            <tbody>
              @for (order of recentOrders; track order.id) {
                <tr class="order-row" (click)="openOrder(order)">
                  <td class="fw-bold primary-color">{{ order.formattedOrderNumber }}</td>
                  <td>{{ order.patientName }}</td>
                  <td>
                    @if (order.orderStatus === OrderStatus.Requested || order.orderStatus === OrderStatus.Rejected) {
                      <span
                        class="badge rounded-pill small"
                        [ngStyle]="getStatusStyle(order.orderStatus)">
                        {{ getStatusLabel(order.orderStatus) }}
                      </span>
                    } @else {
                      <span
                        class="badge rounded-pill small"
                        [ngStyle]="getProgressStyle(order.orderProgress)">
                        {{ getProgressLabel(order.orderProgress) }}
                      </span>
                    }
                  </td>
                  <td class="text-end text-muted">{{ order.dateCreated | appDate:'date':formatting.formats() }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <app-no-items-found text="Не се пронајдени налози."></app-no-items-found>
      }
    </div>
  </div>
</ng-template>

<ng-template #ordersChartCard>
  <div class="card app-card dashboard-tile-card">
    <div class="card-body dashboard-card-body p-3 d-flex flex-column">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0">Број на налози</h5>
      </div>
      <div class="dashboard-chart-shell position-relative flex-grow-1">
        <canvas class="w-100 h-100" #ordersChart aria-label="Orders per month chart"></canvas>
        @if (loadingSummary) {
          <div class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75 rounded-3">
            <app-loading-spinner></app-loading-spinner>
          </div>
        } @else if (summaryError) {
          <div class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75 rounded-3">
            <app-error-alert class="d-block" [message]="summaryError"></app-error-alert>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
